export default __webpack_public_path__ + "static/media/button_goback_th.0873cf06.svg";